<template>
  <div class='divContaniner'>
    <q-card
      :class="[
      enabled !== -1? 'container_box shadow-1 cursor-pointer': 'container_box_disabled']"
      style="width:200px"
    >
      <q-img
        data-cy="img-cityIndex"
        v-if="datos.file"
        :src="imagen.url === null ? require(`@/assets/${imgDefault}`) : imagen.url"
        :alt="datos.name"
        :class="[enabled == false ? 'disabled' : '', 'Imagen']"
        :ratio="1"
        contain
      >
      </q-img>
    </q-card>
    <q-toggle data-cy="toggle-cityIndex" v-model="enabled" :label="enabled==true?'Visible para este municipio':'No visible para este municipio'" @input='changeVisibility(datos)'></q-toggle>
  </div>
</template>

<script>
import { QCard, QImg, QToggle } from 'quasar';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  props: [
    'datos',
    'datosEnabled'
  ],
  data () {
    return {
      imagen: null,
      enabled: this.datosEnabled !== null && this.datosEnabled !== undefined ? this.datosEnabled : null,
      imgDefault: 'img/iconfinder-icon-image.png'
    };
  },
  mixins: [ Resources ],
  created () {
    this.imagen = this.searchResource(this.datos.file, 'imagen');
  },
  watch: {
    datosEnabled () {
      this.enabled = this.datosEnabled !== null && this.datosEnabled !== undefined ? this.datosEnabled : null;
    }
  },

  components: {
    QCard,
    QImg,
    QToggle
  },
  methods: {
    changeVisibility (datos) {
      this.$eventHub.$emit('viewEdited', datos.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.divContaniner{
  text-align: center;
}
.container_box {
  transition: box-shadow 0.3s;
  padding: 0;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);
  &:hover {
    box-shadow: $shadow-8;
  }
  margin: auto;
  padding: 10px;
  margin-top:20px;
}

.container_box_disabled {
  padding: 0;
  margin: auto;
  padding: 10px;
  margin-top:20px;
}

.disabled {
  filter: grayscale(70%);
  opacity: 0.3;
}

.Imagen {
  border-radius: 12px;
}
.toggle{
    margin-top: 61px;
}
</style>
